function HorizontalDivider() {
    return (
        <div className="horizontal_divider"></div>
    )
}
export default HorizontalDivider;